import { c as _taggedTemplateLiteralLoose } from './chunk-eb25cfa0.js';
import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import 'reuse';
import use from './use.js';
import 'react';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import './Box.js';
import '@emotion/is-prop-valid';
import 'react-dom';
import './chunk-0cd02bff.js';
import './chunk-11bd1c20.js';
import Hidden from './Hidden.js';
import 'constate';
import './chunk-061cef7c.js';
import './chunk-22b2fb47.js';
import { a as OverlayContainer, b as OverlayToggle, c as OverlayShow, d as OverlayHide } from './chunk-73fe7b59.js';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  z-index: 19900410;\n  left: 50%;\n  top: 50%;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Overlay = styled(Hidden)(_templateObject(), theme("Overlay"));
Overlay.defaultProps = {
  role: "dialog",
  "aria-modal": true,
  hideOnEsc: true,
  translateX: "-50%",
  translateY: "-50%",
  defaultSlide: "top",
  opaque: true,
  palette: "background",
  tone: -1
};
var Overlay$1 = use(Overlay, "div");
var Overlay$2 = Object.assign(Overlay$1, {
  Container: OverlayContainer,
  Toggle: OverlayToggle,
  Show: OverlayShow,
  Hide: OverlayHide
});
export default Overlay$2;